<template>
  <v-fade-transition>
    <v-layout v-if="similarItems.length" justify-center>
      <v-flex shrink>
        <v-pagination v-model="page" :length="pagesLength" total-visible="10" />
      </v-flex>
    </v-layout>
  </v-fade-transition>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapGetters("matching", ["pivotItem", "similarItemsPage"]),
    ...mapState("matching", [
      "similarItems",
      "similarItemsFetch",
      "similarItemsTotal"
    ]),
    brand() {
      return this.$route.params.brandName;
    },
    classificationId() {
      return this.$route.params.classificationId;
    },
    page: {
      get() {
        return this.similarItemsPage;
      },
      set(page) {
        return this.getSimilarItems({
          brand: this.brand,
          classificationId: this.classificationId,
          page,
          sellerId: this.pivotItem.sellerId,
          historyId: this.pivotItem.historyId
        });
      }
    },
    pagesLength() {
      return Math.ceil(this.similarItemsTotal / this.similarItemsFetch);
    }
  },
  methods: {
    ...mapActions("matching", ["getSimilarItems"])
  }
};
</script>